import { COLOR, SPACING } from 'app-v2/design-tokens'
import { Close } from 'app/assets/icons'
import { breakpoints, style } from 'app/assets/styles'
import { ProductSheet } from 'app/products'
import { useIntl } from 'react-intl'
import Modal from 'react-modal'
import { catalogType } from 'shared/utils'
import styled from 'styled-components'

type ProductSheetModalProps = {
    handleClose: () => void,
    routeId: string,
    width: number,
    isOpen: boolean,
    type: string
}

const ProductSheetModal = ({
    isOpen,
    routeId,
    width,
    handleClose,
    type
}: ProductSheetModalProps) => {
    const { classicModalMobileStyle, centeredModalStyle } = style
    const { medium } = breakpoints
    const intl = useIntl()
    const isMenu = type === catalogType.MENU
    const productRoute = intl.formatMessage({ id: 'routes.product' })
    const menuRoute = intl.formatMessage({ id: 'routes.menu' })
    return (
        <Modal
            isOpen={isOpen}
            style={
                width < medium ? classicModalMobileStyle : centeredModalStyle
            }
            centered>
            <CloseButtonContainer onClick={handleClose}>
                <Close color={COLOR.PRIMARY} size={24} />
            </CloseButtonContainer>
            {routeId && (
                <ProductSheet
                    productPath={`${
                        isMenu ? menuRoute : productRoute
                    }/${routeId}`}
                    fromEcommerce
                />
            )}
        </Modal>
    )
}

export default ProductSheetModal

const CloseButtonContainer = styled.div`
    margin: ${SPACING.M};
    cursor: pointer;
`
